import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AnimationOptions } from 'ngx-lottie';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LanguageService } from 'typescript';
import { DossierService } from '../../services/frapper/dossier.service';
import { EnrollementService } from '../../services/frapper/enrollement.service';
import { JugementsService } from '../../services/frapper/jugements.service';
import { GreffierService } from '../../services/greffier/greffier.service';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../services/public/alertes.service';
import { DocumentService } from '../../services/frapper/document.service';
import { Subscription } from 'rxjs';
import { MyCONST } from '../../CONST/myConst';
import { VisualizeRequisitoireComponent } from '../../dialogs/visualize-requisitoire/visualize-requisitoire.component';
import { VisualizePieceComponent } from '../../dialogs/visualize-piece/visualize-piece.component';
import { ViewDetailsDemandesComponent } from '../../dialogs/view-details-demandes/view-details-demandes.component';
import { DatePipe } from '@angular/common';
import { ViewDetailsJugementComponent } from '../../dialogs/view-details-jugement/view-details-jugement.component';


@Component({
  selector: 'app-resume-dossier',
  templateUrl: './resume-dossier.component.html',
  styleUrls: ['./resume-dossier.component.scss']
})
export class ResumeDossierComponent implements OnInit, OnDestroy {

  @Input() dataType: string = '';

  isModal: any;
  req_ord: any = []
  docs: any = []
  doctype: any
  numero: any
  pieces: any = []
  pageDocs: number = 1
  pagePiece: number = 1
  pageAudience: number = 1
  pageOrd: number = 1
  pageReq: number = 1
  list_requisitoires: any[] = []
  list_ordonnances: any[] = []
  private subscription: Subscription;

  requisitoire = []

  piece_jointes = []
  audiences = []
  
  constructor(
    private modalservice: BsModalService,
    private bsmodalRef: BsModalRef,
    private nbMenuService: NbMenuService,
    private options: ModalOptions,
    private router: Router,
    private dossierService: DossierService,
    private enrollementService: EnrollementService,
    private jugement:JugementsService,
    private alert: AlertesService,
    private documentService: DocumentService,
    private penalService: PenalCourrierService,
    private datePipe: DatePipe,
    private ngxService: NgxUiLoaderService,
    private greffierService: GreffierService
  ) {
   
    let num_dossier_defaulte = penalService.selectedDossier
    this.isModal = this.options.initialState.ismodal;
    this.req_ord = this.options.initialState.req_ord ;
    this.docs = this.options.initialState.docs  ;
    this.doctype = this.options.initialState.doctype;
    this.numero = this.options.initialState.numero; 
    this.pieces = this.options.initialState.pieces;


    this.list_ordonnances =  this.req_ord?.filter(reqOrd => (reqOrd.tag.substring(0,10).toLowerCase() == 'ordonnance'));
    this.list_requisitoires =  this.req_ord?.filter(reqOrd => (reqOrd.tag.substring(0,10).toLowerCase() == 'requisitoi'));
  
    this.getOrdonancesAndRequisitoires()
    this.getAlldocuments()
    // this.getAllAudiences()
  }

  
  ngOnInit(): void {
    console.log('init number dossier', this.numero);
  
    // S'assurer que la valeur actuelle de selectedDossier est chargée immédiatement
    // if (this.numero == undefined || this.numero == null) {


      // S'abonner pour recevoir les futures mises à jour
      let dossier = this.penalService.selectedDossier;
      console.log('-->>>>',dossier);
      
     this.subscription =  this.penalService.selectedDossier$.subscribe(dossier => {
      console.log('Dossier mis à jour',dossier);
        if (dossier != null) {
          this.dossierService.getOneDossier(dossier.name).then((res:any) => {
            try {
              dossier = res.data

              this.numero = dossier.name;
              this.pieces = dossier.pieces_jointe_au_dossier;
              this.getOrdonancesAndRequisitoires();
              this.getAlldocuments();
              console.log('Numero mis à jour via abonnement:', this.numero);
            }catch(e){
              console.log('error get folder',e);
              
            }
          });
        
        }
        
       
      });

      const items = document.querySelectorAll(".accordion a");

      function toggleAccordion() {
        const itemToggle = this.getAttribute('aria-expanded');
        
        for (let i = 0; i < items.length; i++) {
          items[i].setAttribute('aria-expanded', 'false');
        }
        
        if (itemToggle == 'false') {
          this.setAttribute('aria-expanded', 'true');
        }
      }
      
      items.forEach(item => item.addEventListener('click', toggleAccordion));
    
  
  }
  
  

  ngOnDestroy(): void {
    // Se desabonner pour eviter les fuites de memoire
    this.penalService.selectedDossier = []
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal(){
    this.bsmodalRef.hide()
  }

  // openModalDetailJugement(data:any) {

  //   const config: ModalOptions = {
  //     ignoreBackdropClick:true,
  //     backdrop: true,
  //     initialState: {
  //       data: data,

  //     }
  //     }
  //     const modalRef  = this.modalservice.show(ViewDetailsJugementComponent, Object.assign({},config,{class:'modal-xl  '}));

  // }

  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  // getAllAudiences(){
  //   let filter = '[["numero_de_dossier" , "=","'+this.numero+'"]]'
  //   this.jugement.getAllMyJugement(filter).then(res=>{
  //     console.log('list_audiences ==> ',res.data)
  //     if (res.data.length>0) {
  //       this.audiences = res.data
        
      
  //       console.log('list_audiences ==> ',this.audiences)
  //     }else{
  //       this.audiences = []
  //     }
  //   },err=>{
  //     // this.dossierService.list_audiences = []
  //   })
  // }

// get requisitoires and ordonnances
  getOrdonancesAndRequisitoires(){

    let filter = '[["numero_dossier" , "=","'+this.numero+'"]]'
    this.dossierService.getAllMyRequisitoireOrOrdonance(filter).then(res=>{
      this.req_ord = res.data
      if (this.req_ord.length>0) {
        console.log('list_requisitoire_ordonances ==> ',this.req_ord)
        this.list_ordonnances =  res.data.filter(reqOrd => (reqOrd.tag.substring(0,10).toLowerCase() == 'ordonnance'));
        this.list_requisitoires =  res.data.filter(reqOrd => (reqOrd.tag.substring(0,10).toLowerCase() == 'requisitoi'));
  
        console.log('list_ordonances ==> ',this.list_ordonnances)
        console.log('list_req==> ',this.list_requisitoires)
      }
     

    })
  }
// get docs
  async getAlldocuments(){
    // this.ngxService.start()
    //let filter ='ServicePermis'
    // let filter = '[["flag" , "in","'+this.ServicePermis+'"],["numero_du_jugement" , "=","' + this.data.name + '"]]'
    let filter = '[["numero_du_jugement" , "=","' + this.numero + '"]]'


    this.documentService.getAllDocuments(filter).then(res =>{
      //console.log("get result ==>", )
      
      let results = res.data
      if (results != null) {
        for(let res of results){
          res.content = JSON.parse(res.content)
        }
        this.docs = res.data
      } 
      
      console.log('listedocuments ===> ',  this.docs)
      // this.ngxService.stop()
    },err =>{
      // this.ngxService.stop()
    })

  }

  openModalVisualrequistion(data: any) {
    console.log('visualise req', data);
    
    const URL=MyCONST.DOMAIN+data.fichier
    const config: ModalOptions = {
      initialState: {
        data: data,
        url:URL,
        parentModal : null
      }
    }

     // Ouvrir le modal
     const modalRef = this.modalservice.show(VisualizeRequisitoireComponent, Object.assign({}, config, { class: 'modal-lg ' }));

     // Mettre à jour l'option initialState avec le modalRef
  }

  openModalVisualPiece(data: any) {
    const URL=MyCONST.API_URL+data.fichier
    const config: ModalOptions = {
      initialState: {
        data: URL,
        url:URL,
        parentModal : null
      }
    }

     // Ouvrir le modal
     const modalRef = this.modalservice.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

     // Mettre à jour l'option initialState avec le modalRef
  }

  openModalDetailDocument(data: any,type_request: string) {
    console.log('document ', data);
    
    const config: ModalOptions = {
      initialState: {
        data: data,
        type: data.type_demande,
        type_request : type_request,
        show_actions: false
      }
    }


    // Ouvrir le modal
    const modalRef = this.modalservice.show(ViewDetailsDemandesComponent, Object.assign({}, config, { class: 'modal-xl '}));

  }

 


}
